import React, { useState } from "react";
import Login from "./Login";
import SignUp from "./SignUp";
import "./Auth.css";
import coretixAuthImg from "../assets/coretix-auth-img.png";

const AuthModal = ({ isOpen, onClose, initialMode = "login" }) => {
  const [mode, setMode] = useState(initialMode); // 'login' or 'signup'

  if (!isOpen) return null;

  const handleLoginSuccess = async (data) => {
    if (onClose) {
      onClose();
    }
  };

  const handleSignUpSuccess = (data) => {
    // Switch to login mode after successful signup
    setMode("login");
  };

  const handleSwitchToLogin = () => {
    setMode("login");
  };

  const handleSwitchToSignUp = () => {
    setMode("signup");
  };

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      if (onClose) {
        onClose();
      }
    }
  };

  return (
    <div className="auth-modal-overlay" onClick={handleOverlayClick}>
      <div className="auth-modal-content">
        <div className="auth-modal-wrapper">
          {/* Left Column - Form */}
          <div
            className="auth-modal-left"
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
            }}
          >
            <img
              src="/coretix-logo.svg"
              style={{ width: "150px", height: "auto" }}
              alt="Coretix IAI Logo"
              className="auth-modal-logo"
            />

            <div>
              {mode === "login" ? (
                <Login
                  onLoginSuccess={handleLoginSuccess}
                  onSwitchToSignUp={handleSwitchToSignUp}
                />
              ) : (
                <SignUp
                  onSignUpSuccess={handleSignUpSuccess}
                  onSwitchToLogin={handleSwitchToLogin}
                />
              )}
            </div>

            <div className="auth-modal-left-footer">
              <img
                src="/coretix-logo.svg"
                style={{ width: "100px", height: "auto", paddingRight: "8px" }}
                alt="Coretix IAI Logo"
                className="auth-modal-logo"
              />
              <span style={{ color: "#999999" }}>Powered by Synthlinx</span>
            </div>
          </div>

          {/* Right Column - Branding */}
          <div
            className="auth-modal-right"
            style={{ position: "relative", overflow: "hidden" }}
          >
            {/* background svg at 50% opacity */}
            <div
              aria-hidden="true"
              style={{
                position: "absolute",
                inset: 0,
                backgroundImage: "url('/grid-vector-auth.svg')",
                backgroundSize: "cover",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
                opacity: 0.5,
                pointerEvents: "none",
                zIndex: 1,
              }}
            />

            <div
              className="auth-modal-branding"
              style={{ position: "relative", zIndex: 2 }}
            >
              <h4
                style={{ fontWeight: "bold", color: "#FFFFFF", fontSize: 24 }}
              >
                Analyze. Predict. Evolve.
              </h4>
              <p>
                Coretix IAI — your intelligent assistant for code impact
                analysis.
              </p>
              {/* Sparkles + Centered Larger Image */}
              <div
                className="auth-modal-sparkles-wrapper"
                style={{
                  position: "relative",
                  width: "100%",
                  height: 360,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <div
                  className="auth-modal-sparkles"
                  style={{ position: "absolute", inset: 0 }}
                >
                  <span className="sparkle sparkle-1"></span>
                  <span className="sparkle sparkle-2"></span>
                  <span className="sparkle sparkle-3"></span>
                </div>

                <div
                  className="auth-modal-image"
                  style={{
                    position: "relative",
                    zIndex: 3,
                    pointerEvents: "none", // allow clicks through to overlay/close
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "100%",
                    height: "100%",
                  }}
                >
                  <img
                    src={coretixAuthImg}
                    alt="Coretix IAI"
                    style={{
                      width: "520px", // larger size
                      maxWidth: "90%",
                      height: "auto",
                      display: "block",
                      transform: "translateY(-5%)", // slightly higher center
                    }}
                  />
                </div>
              </div>
            </div>
            <button
              className="auth-modal-close"
              onClick={onClose}
              aria-label="Close"
            >
              ×
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthModal;
